import React, { useState } from 'react';
import axios from 'axios';
import { useSpring, animated } from 'react-spring';
import './App.css';

function App() {
  const [license, setLicense] = useState('');
  const [machineData, setMachineData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showUnlinkButton, setShowUnlinkButton] = useState(false);

  const handleInputChange = (e) => {
    setLicense(e.target.value);
  };

  const handleSearch = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await axios.get(`https://189.126.121.47:444/api/Licenca/VerificacaoLicencaCliente?Licenca=${license}`);
      await new Promise((resolve) => setTimeout(resolve, 1000)); // Adiciona um delay de 1 segundo
      setMachineData(response.data); // Supondo que a resposta tem o formato { "serialMaquina": "123456", "dataDoVinculo": "01/01/0001 00:00:00", "nomeDaMaquina": "teste" }
      setTimeout(() => {
        setShowUnlinkButton(true); // Mostra o botão de desvincular após 1 segundo
      }, 1000);
    } catch (err) {
      setError('Licenca não encontrada');
      setMachineData(null);
    }
    setLoading(false);
  };

  const handleUnlink = async () => {
    try {
      await axios.post(`https://189.126.121.47:444/api/Licenca/DesvincularMaquina?maquinaCliente=${machineData?.serialMaquina}`);
      setMachineData(null);
      alert('Máquina desvinculada com sucesso');
    } catch (err) {
      setError('Erro ao desvincular máquina');
    }
  };

  // Defina a animação para o botão de desvincular
  const unlinkButtonAnimation = useSpring({
    opacity: showUnlinkButton ? 1 : 0,
    transform: showUnlinkButton ? 'translateY(0)' : 'translateY(50px)',
    config: { tension: 300, friction: 20 }
  });

  // Defina a animação para os dados da máquina
  const machineDataAnimation = useSpring({
    opacity: machineData ? 1 : 0,
    transform: machineData ? 'translateY(0)' : 'translateY(20px)',
    config: { tension: 300, friction: 20 }
  });

  return (
    <div className="App">
      <div className="container">
        <h1>Vínculo de Máquina AutoPower</h1>
        <input
          type="text"
          placeholder="Digite a licença"
          value={license}
          onChange={handleInputChange}
          className="input-field"
        />
        <button onClick={handleSearch} disabled={loading} className="search-button">
          {loading ? 'Buscando...' : 'Buscar Vínculos'}
        </button>
        {loading && <div className="loader"></div>}
        {error && <p className="error">{error}</p>}
        {machineData && (
          <animated.div style={machineDataAnimation} className="machine-data">
            <p>Máquina vinculada:</p>
            <table className="styled-table">
              <thead>
                <tr>
                  <th>Máquina</th>
                  <th>Data de Vínculo</th>
                  <th>Nome da Máquina</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{machineData.serialMaquina}</td>
                  <td>{machineData.dataDoVinculo}</td>
                  <td>{machineData.nomeDaMaquina}</td>
                </tr>
              </tbody>
            </table>
            <animated.button style={unlinkButtonAnimation} onClick={handleUnlink} className="unlink-button">Desvincular Máquina</animated.button>
          </animated.div>
        )}
      </div>
      <div className="floating-object">
        <a href="https://solucoescad.com.br/">
          <img src={require('./SCAD.png')} alt="Ícone" />
        </a>
      </div>
    </div>
  );
}

export default App;
